import { T } from "../tokens";
import { usePulse } from "../hooks/useMotion";

interface Props {
  color?: string;
  size?: number;
}

export function LiveDot({ color = T.ok, size = 6 }: Props) {
  const p = usePulse(1600);
  return (
    <span style={{ position: "relative", width: size, height: size, display: "inline-block", flexShrink: 0 }}>
      <span style={{
        position: "absolute", inset: 0, borderRadius: "50%",
        background: color, opacity: 0.3 + 0.7 * (1 - p),
        transform: `scale(${1 + p * 1.3})`,
      }}/>
      <span style={{ position: "absolute", inset: 0, borderRadius: "50%", background: color }}/>
    </span>
  );
}
